export default {
	token: '',
	status: [] //possibili valori: 'ENABLED','DELIVERABLE','AVAILABLE','VISIBLE'
};
